module.exports = __webpack_public_path__ + "238a7bcfe1c8dd85abddfe40b791cc4d.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-108.cur
// module id = 434
// module chunks = 0